import React from 'react';

const colorCx = {
  blue:   { bg: 'bg-blue-50 dark:bg-blue-500/10',     text: 'text-blue-600 dark:text-blue-400'     },
  green:  { bg: 'bg-green-50 dark:bg-green-500/10',   text: 'text-green-700 dark:text-green-400'   },
  purple: { bg: 'bg-purple-50 dark:bg-purple-500/10', text: 'text-purple-600 dark:text-purple-400' },
  yellow: { bg: 'bg-yellow-50 dark:bg-yellow-500/10', text: 'text-yellow-700 dark:text-yellow-400' },
};

const StatCard = ({ icon: Icon, label, value, color = 'blue', onClick, clickable = false }) => {
  const c = colorCx[color] ?? colorCx.blue;
  return (
    <div
      className={`bg-cream-100 dark:bg-gray-800/50 rounded-2xl p-6 border border-cream-300 dark:border-gray-700/50 transition-all duration-300 ${
        clickable ? 'hover:border-cream-900/20 dark:hover:border-gray-600/50 cursor-pointer hover:bg-cream-900/10 dark:hover:bg-gray-800/70' : 'hover:border-cream-900/20 dark:hover:border-gray-600/50'
      }`}
      onClick={clickable ? onClick : undefined}
    >
      <div className="flex items-center space-x-3">
        <div className={`${c.bg} p-3 rounded-xl`}>
          <Icon className={c.text} size={20} />
        </div>
        <div>
          <p className="text-2xl font-bold text-gray-900 dark:text-white">{value || 0}</p>
          <p className="text-gray-600 dark:text-gray-400 text-sm">{label}</p>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
